module.exports = __webpack_public_path__ + "img/not_sustainable_transport4_structures.8154134d.svg";